export class DiaryFormNotificationTranslation {
  public id: string;
  public diaryFormId: string;
  public culture: string;
  public text: string;
  public title: string;
  public emailSubject: string;
  public emailBody: string;
  public completedTitle: string;
  public customTitle: string;

  constructor(init?: Partial<DiaryFormNotificationTranslation>) {
    Object.assign(this, init);
  }
}
